module.exports = __webpack_public_path__ + "static/img/banner_pic.36cf976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/home/banner_pic.png
// module id = IuNG
// module chunks = 31